
import { Button } from '@/components/ui/button';
import { ImageIcon } from 'lucide-react';
import { Editor } from '@tiptap/react';

interface ImageButtonProps {
  onImageUploadClick: () => void;
  isUploading: boolean;
}

export default function ImageButton({ onImageUploadClick, isUploading }: ImageButtonProps) {
  return (
    <div className="relative">
      <Button
        size="icon"
        variant="ghost"
        onClick={e => {
          e.preventDefault();
          onImageUploadClick();
        }}
        className="h-8 w-8"
        title="Insert Image"
        disabled={isUploading}
        type="button"
      >
        <ImageIcon className="h-4 w-4" />
      </Button>
    </div>
  );
}
